<template>
	<portal to="sliderDrawer" v-if="value">
		<slider-content v-model="visible"
						@input="input"
						:key="key"
						:slots="$slots.lazy || $slots.default">
		</slider-content>
	</portal>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import SliderContent from "./SliderContent.vue";
import uuid from "../services/uuid";

@Component({
	inheritAttrs: false,
	components: {
		SliderContent
	}
})
export default class Slider extends Vue {
	@Prop({ default: false }) value: boolean;
	@Emit() input() { return this.visible; }

	key = uuid.v4();
	visible: boolean = false;

	@Watch("value", { immediate: true })
	onValueChanged() {
		this.visible = !!this.value;
	}

}
</script>